export default {
  botName: process.env.VUE_APP_TELEGRAM_BOT_NAME
}
